import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}

import Login from '../views/login/login.vue'//登录页面
import Home from '../views/Home/Home.vue'//主页面

//系统设置
import SystemModule from '../components/systemSettings/systemModule.vue'//模块设置
import SystemRole from '../components/systemSettings/systemRole.vue'//角色管理
import SystemUser from '../components/systemSettings/systemUser.vue'//用户管理
import SystemCode from '../components/systemSettings/systemCode.vue'//系统代码
import SystemGlobal from '../components/systemSettings/systemGlobal.vue'//全局参数
import SystemCorporateAccount from '../components/systemSettings/systemCorporateAccount.vue'//企业账户
import SystemEnterpriseInformation from '../components/systemSettings/systemEnterpriseInformation.vue'//企业信息
//销售
import SalesCustomer from '../components/sales/salesCustomer.vue'//客户管理
import SalesBigCustomers from '../components/sales/salesBigCustomers.vue'//客户管理
import SalesCarManagement from '../components/sales/salesCarManagement.vue'//车辆管理
import SalesDeliveryPlace from '../components/sales/salesDeliveryPlace.vue'//配送地
import SalesBigDeliveryPlace from '../components/sales/salesBigDeliveryPlace.vue'//配送地--一级
import SalesMaterialPrice from '../components/sales/salesMaterialPrice.vue'//物料价格管理
import SalesPreferential from '../components/sales/salesPreferential.vue'//优惠管理
import SalesBillDetails from '../components/sales/salesBillDetails.vue'//账单明细表
import SalesDispatchManagement from '../components/sales/salesDispatchManagement.vue'//派单记录
import SalesEntryOrder from '../components/sales/salesEntryOrder.vue'//派单记录
import SalesFinancialAudit from '../components/sales/salesFinancialAudit.vue'//财务审核
Vue.use(VueRouter)

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes:[
		{
			path: '/',
			redirect: '/Login',//重定向
			component: Login
		},
		{
			path: '/Login',//登录页面
			name: 'Login',
			component: Login,
		},
		{
			path: '/Home',//主页面
			name: 'Home',
			component: Home,
			children:[//子路由
				{
					path: 'SystemModule',//模块设置
					name: 'SystemModule',
					component: SystemModule,
				},
				{
					path: 'SystemRole',//角色管理
					name: 'SystemRole',
					component: SystemRole,
				},
				{
					path: 'SystemUser',//用户管理
					name: 'SystemUser',
					component: SystemUser,
				},
				{
					path: 'SystemCode',//系统代码
					name: 'SystemCode',
					component: SystemCode,
				},
				{
					path: 'SystemGlobal',//全局参数
					name: 'SystemGlobal',
					component: SystemGlobal,
				},
				{
					path: 'SystemCorporateAccount',//企业账户
					name: 'SystemCorporateAccount',
					component: SystemCorporateAccount,
				},
				{
					path: 'SystemEnterpriseInformation',//企业信息
					name: 'SystemEnterpriseInformation',
					component: SystemEnterpriseInformation,
				},
				{
					path: 'SalesCustomer',//客户管理
					name: 'SalesCustomer',
					component: SalesCustomer,
				},
				{
					path: 'SalesBigCustomers',//大客户管理
					name: 'SalesBigCustomers',
					component: SalesBigCustomers,
				},
				{
					path: 'SalesCarManagement',//车辆管理
					name: 'SalesCarManagement',
					component: SalesCarManagement,
				},
				{
					path: 'SalesDeliveryPlace',//配送地
					name: 'SalesDeliveryPlace',
					component: SalesDeliveryPlace,
				},
				{
					path: 'SalesBigDeliveryPlace',//配送地--一级
					name: 'SalesBigDeliveryPlace',
					component: SalesBigDeliveryPlace,
				},
				{
					path: 'SalesMaterialPrice',//物料价格管理
					name: 'SalesMaterialPrice',
					component: SalesMaterialPrice,
				},
				{
					path: 'SalesPreferential',//优惠管理
					name: 'SalesPreferential',
					component: SalesPreferential,
				},
				{
					path: 'SalesBillDetails',//账单明细表
					name: 'SalesBillDetails',
					component: SalesBillDetails,
				},
				{
					path: 'SalesDispatchManagement',//派单记录
					name: 'SalesDispatchManagement',
					component: SalesDispatchManagement,
				},
				{
					path: 'SalesEntryOrder',//录入
					name: 'SalesEntryOrder',
					component: SalesEntryOrder,
				},
				{
					path: 'SalesFinancialAudit',//财务审核
					name: 'SalesFinancialAudit',
					component: SalesFinancialAudit,
				},
			]
		}
	]
})
router.beforeEach((to,from,next)=>{
  if(to.path==='/Login'){
    return next()
  }else{
    var uobj=sessionStorage.getItem('token')
    if(!uobj){
      next('/Login')
    }else{
		next()
    }
  }
})
export default router
